import React from 'react'
import TableContent from '../../components/TableContent'
const url = 'connector/openai-storage'
const item = 'OpenAI Storage'
const items = 'OpenAI Storages'

const OpenAIStorageConnector = () => {
  return <TableContent url={url} type={'connector-openai-storage'} item={item} items={items} />
}
export default OpenAIStorageConnector
